import { SimpleSelectOption } from '@workwave-tidal/core/components'

import { Field } from './Field'

export type MergedBarcodePod = uui.domain.client.rm.BarcodePod & {
  isDriverBarcode?: boolean
}

interface Props {
  value: MergedBarcodePod[]
  onChange: (pod: uui.domain.client.rm.BarcodePod, index: number) => void
  testId?: string
  fieldDisabled?: boolean
  options: SimpleSelectOption<string>[]
  accountPreferences: uui.domain.client.rm.AccountPreferences
  driverBarcodeOptions?: SimpleSelectOption<string>[]
  driverBarcodeLabel?: string
  driverBarcodeTooltip?: string
}

export function Barcodes(props: Props) {
  const {
    value,
    onChange,
    testId,
    fieldDisabled,
    options,
    accountPreferences,
    driverBarcodeOptions,
    driverBarcodeLabel,
    driverBarcodeTooltip,
  } = props

  return (
    <>
      {value.map((pod, index) => {
        // Use driver barcode options for driver barcodes, regular options otherwise
        const baseOptions = pod.isDriverBarcode ? driverBarcodeOptions || options : options
        const opt: SimpleSelectOption<string>[] = baseOptions.map(o => {
          return {
            ...o,
            selected: pod.barcodeStatus === o.value,
          }
        })

        // Filter out UNSCANNED option for driver barcodes
        const filteredOptions = pod.isDriverBarcode ? opt.filter(o => o.value !== 'UNSCANNED') : opt

        return (
          <Field
            barcodeValue={pod}
            options={filteredOptions}
            accountPreferences={accountPreferences}
            onChange={podUpdated => onChange(podUpdated, index)}
            disabled={fieldDisabled || pod.isDriverBarcode}
            key={`${pod.barcode}-${index}`}
            testId={`${testId}-${pod.barcode}`}
            isDriverBarcode={pod.isDriverBarcode}
            driverBarcodeLabel={driverBarcodeLabel}
            driverBarcodeTooltip={driverBarcodeTooltip}
          />
        )
      })}
    </>
  )
}
